import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wrap any screen that requires a paid plan.
// If user is not paid, redirect them to the pricing/upgrade page.
// If user is not logged in at all, send them to sign in.

export default function ProtectedRoute({ children, requirePaid = false }) {
  const { user, isPaid } = useAuth();

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  if (requirePaid && !isPaid) {
    return <Navigate to="/upgrade" replace />;
  }

  return children;
}